import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "flex-row-box work-manage-page-voice",
  style: {"justify-content":"flex-start","align-items":"flex-start","margin-top":"20px"}
}
const _hoisted_2 = {
  class: "flex-row-box",
  style: {"justify-content":"flex-start","align-items":"flex-start","flex-wrap":"wrap"}
}
const _hoisted_3 = {
  class: "flex-row-box video-inner-box",
  style: {"justify-content":"center"}
}
const _hoisted_4 = { class: "video-name" }
const _hoisted_5 = {
  key: 0,
  class: "video-time"
}
const _hoisted_6 = {
  key: 1,
  class: "video-time"
}
const _hoisted_7 = { class: "active-text-plain" }
const _hoisted_8 = { class: "video-time" }
const _hoisted_9 = { class: "flex-row-box opt-btn-wrap" }
const _hoisted_10 = { class: "code-bg" }

import {ref, onMounted, computed} from 'vue';
import { useRouter } from "vue-router";
import { useMainStore } from '@/pinia';


export default /*@__PURE__*/_defineComponent({
  __name: 'voice',
  props: {
  isGenerated: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const store = useMainStore();

const router = useRouter();
const props = __props

const works = ref([
  // {
  //   name: '未命名',
  //   createTime: '2024-02-08',
  //   process:'素材提交成功',
  //   status: 0,
  // },{
  //   name: '未命名',
  //   createTime: '2024-02-08',
  //   process:'审核中',
  //   programs:'xxx,xxx,xxxx',
  //   status: 2
  // }
])

const worksTemp = computed(() => {
  if(props.isGenerated) {
    return works.value.filter(v => v.status == 2);
  } else {
    return works.value.filter(v => v.status == 0);
  }
})

const visible = ref(false)
const addNewVideo = () => {
  if(store.userInfo.soundCloneStatus) {
    router.push('/digitalman-customized');
  } else {
    visible.value = true;
  }
};

const handleCommand = (command)=>{
  console.log(command)
}

const goDetail = ()=>{
  router.push({name:'WorkManageVoice'});
}

onMounted(()=>{

})


return (_ctx: any,_cache: any) => {
  const _component_CirclePlus = _resolveComponent("CirclePlus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_svgIcon = _resolveComponent("svgIcon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "add-box flex-column-box",
      onClick: addNewVideo,
      style: {"justify-content":"center","align-items":"center","cursor":"pointer"}
    }, [
      _createVNode(_component_el_icon, { size: "1.8vw" }, {
        default: _withCtx(() => [
          _createVNode(_component_CirclePlus)
        ]),
        _: 1
      }),
      _cache[1] || (_cache[1] = _createTextVNode(" 快速创建 "))
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(worksTemp.value, (v, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "video-outer-box",
          key: i
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_svgIcon, {
              iconClass: "voiceicon",
              width: "80px",
              height: "80px"
            })
          ]),
          _createElementVNode("p", _hoisted_4, _toDisplayString(v.name), 1),
          (v.status==2)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, "应用项目：" + _toDisplayString(v.programs), 1))
            : _createCommentVNode("", true),
          (v.status==0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                _cache[2] || (_cache[2] = _createTextVNode("进度：")),
                _createElementVNode("span", _hoisted_7, _toDisplayString(v.process), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_8, "创建时间：" + _toDisplayString(v.createTime), 1),
          _createElementVNode("div", _hoisted_9, [
            (v.status==0)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  size: "small",
                  onClick: ($event: any) => (goDetail(v))
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("查看详情")
                  ])),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (v.status==2)
              ? (_openBlock(), _createBlock(_component_el_dropdown, {
                  key: 1,
                  size: "small",
                  "split-button": "",
                  type: "primary",
                  onCommand: handleCommand
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, { command: "video" }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode("新建音视频")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, { command: "reactiveMan" }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createTextVNode("新建交互数字人")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _cache[6] || (_cache[6] = _createTextVNode(" 去应用 "))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("a", null, [
              (v.status==2)
                ? (_openBlock(), _createBlock(_component_svgIcon, {
                    key: 0,
                    iconClass: "videoedit",
                    style: {"margin-right":"6px"},
                    width: "1.2vw"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_svgIcon, {
                iconClass: "videodel",
                width: "1.2vw"
              })
            ])
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      title: "添加客服企业微信，开通此功能",
      width: "500px",
      center: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_image, {
            src: require('@/assets/images/ewcode.png')
          }, null, 8, ["src"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})